module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAlCAMAAADyQNAxAAAAYFBMVEVKUmBKUmBKUmBKUmBKUmBKUmAAAABKUmBKUmBKUmBKUmBKUmBKUmBKUmBKUmBKUmBKUmBKUmDh7fNYYG15g45weYVsdYG7xs6QmqR3gIzU4OacprCCjJfDz9bV4Oeps7wGe6C/AAAAEXRSTlPx9zzNEY4AieO+qIJQSzAcDlSt8OUAAADBSURBVDjLzZPbDoMgDECrc3X3DaoFb9v//+ViSJooDSz6svNCSk7SUlpAxFeVBBEB71BkqBEqMDngBiWYLPVP1nGDRdwITLrFzi5wrFijjRgji60Cry2nWW5lkV0y8Wc+SCw1oQ83vLQaSdIRdc6+/TRHrW4NoZIhRJEl5ZL3JI/Rrc5Qb21PpktZZHyonfZYesZ89Xs7IV3VLbYqnPptgbZMjp6SN010fjsE4laIN03n/60r4CkrFQ/A5+WQ5lziFwrOU0fcWzvUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tiktok.png
// module id = YjT/
// module chunks = 1